import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { ModalDialog } from '../Modal';

import { deleteBrand } from '../../stores/dataorch';

const CustomButton = withStyles({
  root: {
    backgroundColor: '#d63031',
    color: '#ffffff',
    borderColor: '#d63031',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: '#d63031',
      borderColor: '#d63031',
    },
    '&:active': {
      color: '#ffffff',
      backgroundColor: '#d63031',
      borderColor: '#d63031',
    },
  },
})(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  text: {
    fontSize: '24px',
    color: '#4a4a4a',
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  btn: {
    fontSize: '12px',
    textTransform: 'uppercase',
  },
}));

function BrandDelete({ selectedBrand, onOk, onClose }) {
  const classes = useStyles();

  const handleDelete = () => {
    deleteBrand(selectedBrand.id)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) return onOk('Brand was deleted');
      })
      .catch((error) => console.log(error));
  };

  return (
    <ModalDialog title="" onOk={onOk} onClose={onClose} open noActions>
      <div className={classes.root}>
        <span className={classes.text}>{`Are you sure to delete ${selectedBrand.name}?`}</span>
        <div className={classes.action}>
          <Button variant="outlined" color="default" className={classes.btn} onClick={onClose}>
            Cancel
          </Button>
          <CustomButton variant="contained" color="primary" className={classes.btn} onClick={handleDelete}>
            Delete
          </CustomButton>
        </div>
      </div>
    </ModalDialog>
  );
}

export default BrandDelete;
